import {NoteDetailRes} from "./note/note.contract";
import {Type} from 'class-transformer';

export class RelationDetailRes {
    id!: number;
    @Type(() => RelationTypeRes)
    type!: RelationTypeRes
    @Type(() => NoteDetailRes)
    note!: NoteDetailRes
}

export class RelationTypeRes {
    id!: number
    name!: string
}


export class RelationCreateReq {
    parentId!: number
    noteId!: number;
    relationTypeID!: number;

    constructor(relation?: RelationDetailRes) {
        if (relation != undefined) {
            this.noteId = relation.note.id
            this.relationTypeID = relation.type.id
        } else {
            this.relationTypeID = 1;
        }
    }
}
